import { IMyImageQuery } from '../interfaces/my-image.query.interface';

export class MyImage {
    id: string;
    inLibrary: boolean;
    selected: boolean;
    unsplash: {
        unsplashId: string;
        authorName: string;
        authorProfileUrl: string;
    } = { unsplashId: '', authorName: '', authorProfileUrl: '' };
    url: string;
    smallUrl: string;
    thumbUrl: string;
    mimeType: string;
    name: string;
    originalName: string;
    myImagesSource: string;

    constructor(query: IMyImageQuery) {
        this.id = query.id.toString();
        this.inLibrary = query.in_library;
        this.selected = false;
        if (query.unsplash) {
            this.unsplash.unsplashId = query.unsplash.unsplash_id.toString();
            this.unsplash.authorName = query.unsplash.author_name;
            this.unsplash.authorProfileUrl = query.unsplash.author_profile_url;
        } else {
            this.unsplash = null;
        }
        this.url = query.url;
        this.smallUrl = query.small_url;
        this.thumbUrl = query.thumb_url;
        this.mimeType = query.mime_type;
        this.name = query.name;
        this.originalName = query.original_name;
        this.myImagesSource = query.my_images_source;
    }
}
